import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Carousel, { Modal, ModalGateway } from 'react-images';

import View from './View';
import { getImageActions, clearImages } from '../../services/imageService/actions';

const navigationPrevStyles = {
  left: 'calc(50% - 50vw + 20px)',
};

const navigationNextStyles = {
  right: 'calc(50% - 50vw + 20px)',
};

class Image extends Component {
  componentDidMount() {
    const {
      attachments,
      actions,
    } = this.props;

    actions.clearImages();
    attachments.forEach((attachment) => {
      actions.getImage(attachment.id, attachment.name, attachment.url);
    });
  }

  render() {
    const { images, onClose } = this.props;
    const imagesArray = Object.values(images)
      .map((image) => ({
        contentType: image.contentType,
        src: image.src,
      }));

    if (imagesArray.length > 0) {
      return (
        <ModalGateway>
          <Modal onClose={onClose}>
            <Carousel
              views={imagesArray}
              components={{ View }}
              styles={{
                navigationPrev: (base) => ({ ...base, ...navigationPrevStyles }),
                navigationNext: (base) => ({ ...base, ...navigationNextStyles }),
              }}
            />
          </Modal>
        </ModalGateway>
      );
    }
    return null;
  }
}

Image.propTypes = {
  actions: PropTypes.shape({
    clearImages: PropTypes.func.isRequired,
    getImage: PropTypes.func.isRequired,
  }).isRequired,
  onClose: PropTypes.func,
  attachments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  images: PropTypes.shape({}).isRequired,
};

const mapStateToProps = ({ imageService }) => ({
  images: imageService.images,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    getImage: getImageActions.common,
    clearImages,
  }, dispatch),
});

Image.defaultProps = {
  onClose: () => { },
};

export default connect(mapStateToProps, mapDispatchToProps)(Image);
